import { FC, useContext } from "react";

import PageLayout from "@/layout/Page";
import { WhiteLabelLayout } from "@/layout/WhiteLabel";
import FindBestPriceAccordion from "@/components/FindBestPriceDetails/FindBestPriceDetails";
import GetAdvantageCard from "@/components/GetAdvantageCardCTA/GetAdvantageCardCTA";
import { ThemeSelectorContext } from "@/context/index";

const DrugDetails: FC = () => {
  const { client } = useContext(ThemeSelectorContext);

  return (
    <>
      {client && (
        <WhiteLabelLayout>
          <FindBestPriceAccordion />
        </WhiteLabelLayout>
      )}
      {!client && (
        <PageLayout>
          <FindBestPriceAccordion />
          <GetAdvantageCard />
        </PageLayout>
      )}
    </>
  );
};

export default DrugDetails;
